export default "__VITE_ASSET__BLFyR2Zc__"